import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { RegisterComponent } from './register/register.component';
import { AuthGuard } from './_guards/auth.guard';
import { ConfirmEmailComponent } from './confirm-email/confirm-email.component';
import { LoginComponent } from './login/login.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { TwoFactorAuthenticationComponent } from './two-factor-authentication/two-factor-authentication.component';
import { TranslationLoaderResolver } from './_resolvers/translation-loader.resolver';
import { PendingUserComponent } from './pending_user/pending-user.component';
import { QueriesComponent } from './queries/queries.component';

const routes: Routes = [
  { path: '', component: LoginComponent },

  { path: 'login', redirectTo: '', pathMatch: 'full' },
  { path: 'confirm-email', component: ConfirmEmailComponent },
  { path: 'forgot-password', component: ForgotPasswordComponent },
  { path: 'reset-password', component: ResetPasswordComponent },
  { path: '2fa', component: TwoFactorAuthenticationComponent },
  { path: 'ms-auth', component: ResetPasswordComponent },
  { path: 'pending-user', component: PendingUserComponent },

  { path: 'queries', component: QueriesComponent },
  { path: 'queries/:numDays', component: QueriesComponent },
  { path: 'queries/:numDays/:idCompany', component: QueriesComponent },

  {
    path: 'home',
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    resolve: { model: TranslationLoaderResolver },
    loadChildren: () =>
      import('./home/home-routing.module').then((m) => m.HomeRoutingModule),
  },
  { path: '**', component: PageNotFoundComponent },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      relativeLinkResolution: 'legacy',
      scrollPositionRestoration: 'top',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
